import { toast } from "react-toastify";
import axios from "axios";

const actionTypes = {
    PROFILE_GET_REQUEST: 'PROFILE_GET_REQUEST',
    PROFILE_GET_RESPONSE: 'PROFILE_GET_RESPONSE',
    PROFILE_UPDATE_RESPONSE: 'PROFILE_UPDATE_RESPONSE',
    CUSTOMER_SAVE_CARD_REQUEST: 'CUSTOMER_SAVE_CARD_REQUEST',
    CUSTOMER_SAVE_CARD_RESPONSE: 'CUSTOMER_SAVE_CARD_RESPONSE',
    CUSTOMER_CREDIT_CARD_REQUEST: 'CUSTOMER_CREDIT_CARD_REQUEST',
    CUSTOMER_CREDIT_CARD_RESPONSE: 'CUSTOMER_CREDIT_CARD_RESPONSE',
    CUSTOMER_DELETE_CARD_REQUEST: 'CUSTOMER_DELETE_CARD_REQUEST',
    CUSTOMER_DELETE_CARD_RESPONSE: 'CUSTOMER_DELETE_CARD_RESPONSE',

    SAVEBUTTON_DISABLED: 'SAVEBUTTON_DISABLED',
    SAVEBUTTON_ACTIVE: 'SAVEBUTTON_ACTIVE',

    CUSTOMER_SELECTED_CARD_DELETE_REQUEST: 'CUSTOMER_SELECTED_CARD_DELETE_REQUEST',
    CUSTOMER_SELECTED_CARD_DELETE_RESPONSE: 'CUSTOMER_SELECTED_CARD_DELETE_RESPONSE'
};

export const saveButtonDisable = () => (dispatch, getState) => {
    const requestAction = {
        type: actionTypes.SAVEBUTTON_DISABLED,
        payload: {
            buttonDisable: false
        }
    };

    dispatch(requestAction);
};

export const saveButtonActive = () => (dispatch, getState) => {
    const requestAction = {
        type: actionTypes.SAVEBUTTON_ACTIVE,
        payload: {
            buttonDisable: true
        }
    };

    dispatch(requestAction);
};

export const saveCustomerCreditCard = (stripeToken) => async (dispatch, getState) => {

    var token = getState().account.user.token;
    const url = `api/account/setcustomercreditcard`;
    dispatch({
        type: actionTypes.CUSTOMER_SAVE_CARD_REQUEST,
        payload: {
            isLoading: true
        }
    });

    return fetch(url, {
        method: 'post',
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json; charset=UTF-8',
            'Accept': 'application/json',
        },
        body: JSON.stringify({
            "stripeToken": stripeToken
        })
    }).then(handleResponse).then(
        result => {
            if (result.statusCode === 200) {
                dispatch({
                    type: actionTypes.CUSTOMER_SAVE_CARD_RESPONSE,
                    payload: {
                        isLoading: false
                    }
                });

                return result;
            }
            else {
                dispatch({
                    type: actionTypes.CUSTOMER_SAVE_CARD_RESPONSE,
                    payload: {
                        isLoading: false
                    }
                });

                return result;
            }
        },
        error => {
            if (error.status === 401) {
                //dispatch(push('/profile'));
            } else {
                toast.warn("Houston we have a problem !");
                return error.error;
            }
        });
};

export const deleteCustomerCreditCard = (cardToken, customerId) => async (dispatch, getState) => {
    dispatch({
        type: actionTypes.CUSTOMER_DELETE_CARD_REQUEST,
        payload: {
            isLoading: true
        }
    });
    const url = `api/account/deletestripecreditcard`;
    await axios({
        method: 'post',
        url: url,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getState().account.user.token
        },
        data: {
            BankId: cardToken,
            StripeCustomerId: customerId
        }
    }).then(result => {

        if (result.status === 200) {
            dispatch({
                type: actionTypes.CUSTOMER_DELETE_CARD_RESPONSE,
                payload: {
                    isLoading: false
                }
            });
            toast.success('Credit Card Deleted', {
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
        }
        else {

            toast.error('Credit Cards Deleted is failed', {
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
        }
    });
};

export const deleteSelectedCreditCard = (creditCards) => async (dispatch, getState) => {

    dispatch({
        type: actionTypes.CUSTOMER_SELECTED_CARD_DELETE_REQUEST,
        payload: {
            isLoading: true
        }
    });
    const url = `api/account/deleteselectedstripecreditcard`;
    await axios({
        method: 'post',
        url: url,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getState().account.user.token
        },
        data: {
            creditCards: creditCards
        }

    }).then(result => {

        if (result.data) {
            dispatch({
                type: actionTypes.CUSTOMER_SELECTED_CARD_DELETE_RESPONSE,
                payload: {
                    isLoading: false
                }
            })

            toast.success('Credit Cards Deleted', {
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
        }
        else {

            toast.error('Credit Cards Deleted is failed', {
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
        }
    })
}

export const getCustomerCreditCards = () => async (dispatch, getState) => {

    var token = getState().account.user.token;
    const url = `api/Account/GetCustomerStripeCreditCards`;
    dispatch({
        type: actionTypes.CUSTOMER_CREDIT_CARD_REQUEST,
        payload: {
            isLoading: true
        }
    });
    return fetch(url, {
        method: 'get',
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json; charset=UTF-8',
            'Accept': 'application/json',
        },
    }).then(handleResponse).then(
        result => {
            if (result.statusCode === 200) {
                dispatch({
                    type: actionTypes.CUSTOMER_CREDIT_CARD_RESPONSE,
                    payload: {
                        isLoading: false, cards: result.cards, stripePK: result.stripePK
                    }

                });
                return result;
            }
            else {
                toast.warn("Houston we have a problem !");
                return "error";
            }
        },
        error => {
            if (error.status === 401) {
                toast.warn("Houston we have a problem !");
                return "error";
            } else {
                toast.warn("Houston we have a problem !");
                return error.error;
            }
        });
};

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                return Promise.reject({ status: response.status });
            }
            const error = text;
            return Promise.reject({ status: response.status, error });
        }
        return data;
    });
}


// WEBPACK FOOTER //
// ./src/actions/PaymentAction.js